(function(){
  if(window.__brfLh)return;window.__brfLh=true;
  if(!(window.matchMedia&&matchMedia('(hover: hover) and (pointer: fine)').matches))return;
  if(matchMedia('(prefers-reduced-motion: reduce)').matches)return;
  var SEL='.brf-hc__logo',n=0;
  function svg(){
    n++;var g='brfLhG'+n;
    return '<svg viewBox="0 0 100 100" aria-hidden="true"><defs><linearGradient id="'+g+'" x1="0" y1="0" x2="1" y2="0"><stop offset="0" stop-color="#8E0A1F"/><stop offset=".3" stop-color="#D21932"/><stop offset=".5" stop-color="#EE3B50"/><stop offset=".72" stop-color="#C8102E"/><stop offset="1" stop-color="#7E0716"/></linearGradient></defs>'
      +'<g class="brf-lh__wall"><path d="M22 46h56v42H22z" fill="#C8102E"/><path d="M22 46h56v6H22z" fill="#000" opacity=".22"/><path d="M34 52v36M66 52v36" stroke="#8E0A1F" stroke-width="1.6" opacity=".6"/></g>'
      +'<path class="brf-lh__door" d="M42 88V70a8 8 0 0 1 16 0v18z" fill="#FAF5EC"/>'
      +'<g class="brf-lh__roof"><path d="M8 50L50 12L92 50z" fill="url(#'+g+')"/><path d="M50 14L30 48M50 14L70 48" stroke="#6E0613" stroke-width="1.6" opacity=".45"/><path d="M8 50L50 12L92 50" fill="none" stroke="#E3B341" stroke-width="3" stroke-linejoin="round"/></g>'
      +'</svg><b>Home</b>';
  }
  function prep(a){
    if(a.__brfLh)return;a.__brfLh=true;
    if(!a.querySelector('img'))return;
    var o=document.createElement('span');o.className='brf-lh';o.setAttribute('aria-hidden','true');o.innerHTML=svg();
    a.classList.add('brf-lh-host');a.appendChild(o);
    a.addEventListener('mouseleave',function(){a.classList.remove('is-home');});
    a.addEventListener('focus',function(){a.classList.remove('is-home');});
  }
  document.addEventListener('mouseover',function(e){
    var a=e.target.closest&&e.target.closest(SEL);if(!a)return;
    prep(a);if(a.classList.contains('brf-lh-host'))a.classList.add('is-home');
  });
})();
